export const copyTextToClipboard = text => new Promise((resolve, reject) => {
  const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
  if (isApiSupported) {
    navigator.clipboard.writeText(text).then(() => resolve(), e => reject(e));
  } else {
    reject('Clipboard API is not supported');
  }
});